import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import PageHero from '../components/PageHero'
import SectionHeading from '../components/SectionHeading'
import ProcessTimeline from '../components/ProcessTimeline'
import ScrollReveal from '../components/ScrollReveal'
import CTASection from '../components/CTASection'
import { bgPhoto } from '../utils/img'
import './About.css'

const values = [
  {
    title: 'Precision',
    text: 'Run-of-show timing, vendor coordination and setup checklists — the parts no guest sees but every guest feels.',
  },
  {
    title: 'Craft',
    text: 'Décor and staging built with an eye for photography and scale, not just a checklist of props.',
  },
  {
    title: 'Presence',
    text: "We're on-site from setup to strike, so you're never chasing updates on your own event day.",
  },
]

export default function About() {
  return (
    <>
      <SEO
        title="About AS Elite Gatherings | Event Planners in Marthandam, Tamil Nadu"
        description="Meet the team behind AS Elite Gatherings — precision-run weddings, corporate events and stage decoration across Marthandam and Kanniyakumari district."
        keywords="about AS Elite Gatherings, event planners Marthandam, wedding planning team Tamil Nadu, event management company Kanniyakumari, corporate event specialists Marthandam"
        path="/about"
      />
      <PageHero
        eyebrow="About Us"
        title="An event studio built around one idea"
        text="That the people hosting a gathering should get to enjoy it as much as their guests do."
        image='/images/bg/bg2.webp'
      />

      <section className="section">
        <div className="container about-story">
          <ScrollReveal direction="left" className="about-story-media">
            <img src={bgPhoto('/images/logo/logo1.webp', 900, 1050)} alt="AS Elite Gatherings team setting a stage" />
          </ScrollReveal>
          <ScrollReveal direction="right" delay={100} className="about-story-copy">
            <span className="eyebrow">Our Story</span>
            <h2 className="gold-underline animate">Rooted in Marthandam, built for every kind of gathering</h2>
            <p>
              AS Elite Gatherings started with a simple observation: the events that
              are remembered aren't the ones with the biggest budget — they're the
              ones where nothing felt out of place. That's the standard we plan to.
            </p>
            <p>
              Today, we handle <Link to="/services#corporate-events">corporate events</Link>,{' '}
              <Link to="/services#product-launch">product launches</Link>,{' '}
              <Link to="/services#private-party">private parties</Link>,{' '}
              <Link to="/services#wedding">weddings</Link>,{' '}
              <Link to="/services#stage-decoration">stage decoration</Link>, and{' '}
              <Link to="/services#cultural-award-shows">award & cultural shows</Link> across
              Marthandam and the surrounding region — sharing highlights, reveal
              moments and behind-the-scenes setups from every one of them along the way.
            </p>
            <p>
              Whether it's a fifty-guest anniversary dinner or a full-scale{' '}
              <Link to="/services#wedding">wedding</Link> across three functions, the process
              is the same: listen first, design deliberately, execute without drama. See the{' '}
              <Link to="/services">full list of services</Link> we offer, or{' '}
              <Link to="/booking">book your event</Link> to get started.
            </p>
          </ScrollReveal>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <SectionHeading eyebrow="What We Value" title="The standards behind every event we run" center />
          <div className="values-grid">
            {values.map((v, i) => (
              <ScrollReveal key={v.title} delay={i * 100} className="value-card card">
                <span className="value-index">0{i + 1}</span>
                <h3>{v.title}</h3>
                <p>{v.text}</p>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHeading eyebrow="How We Work" title="From first call to closing toast" center />
          <ProcessTimeline />
        </div>
      </section>

      <CTASection />
    </>
  )
}
